import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { errorToast, successToast } from '@components/toasts/Toasts';
import { ApiError } from '@shared/api/errors';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { admitGuest } from '../apiHelpers';

export const useAdmitGuest = (
  reservationId: string,
  onSuccess?: () => void,
) => {
  const { id: restaurantId } = useRestaurant();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      admitGuest({
        restaurantId,
        reservationId,
      }),
    onError: (error) => {
      if (error instanceof ApiError) {
        errorToast({
          message: `Failed to check in guest: ${error.message}`,
        });
      } else {
        errorToast({
          message: 'Failed to check in guest. Please try again.',
        });
      }
    },
    onSuccess: () => {
      successToast({ message: 'Guest checked in successfully.' });
      onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: [
          'restaurants',
          restaurantId,
          'occupants',
          'reservation',
          reservationId,
        ],
      });
    },
  });
};
